/**
 * @generated SignedSource<<1b1908e74c08946e015dfe4164c6c5aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PopupListPage_site$data = {
  readonly slug: string;
  readonly popupGroups: {
    readonly __id: string;
    readonly totalCount: number;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly slug: string;
        readonly " $fragmentSpreads": FragmentRefs<"PopupTableDataRow_popupGroup">;
      } | null;
    } | null> | null;
  };
  readonly popupCsv: any;
  readonly id: string;
  readonly " $fragmentType": "PopupListPage_site";
};
export type PopupListPage_site = PopupListPage_site$data;
export type PopupListPage_site$key = {
  readonly " $data"?: PopupListPage_site$data;
  readonly " $fragmentSpreads": FragmentRefs<"PopupListPage_site">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "popupGroups"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v2 = {
  "kind": "Variable",
  "name": "device",
  "variableName": "device"
},
v3 = {
  "kind": "Variable",
  "name": "funnelIds",
  "variableName": "funnelIds"
},
v4 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "order"
},
v5 = {
  "kind": "Variable",
  "name": "pageIds",
  "variableName": "pageIds"
},
v6 = {
  "kind": "Variable",
  "name": "pageKind",
  "variableName": "pageKind"
},
v7 = {
  "kind": "Variable",
  "name": "sourceId",
  "variableName": "sourceId"
},
v8 = {
  "kind": "Variable",
  "name": "status",
  "variableName": "status"
},
v9 = {
  "kind": "Variable",
  "name": "withArchived",
  "variableName": "withArchived"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 120,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "device"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "funnelIds"
    },
    {
      "defaultValue": {
        "direction": "ASC",
        "field": "NAME"
      },
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "pageIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "pageKind"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchTerm"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sourceId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "status"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "withArchived"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./PopupListPage_Query.graphql'),
      "identifierField": "id"
    }
  },
  "name": "PopupListPage_site",
  "selections": [
    (v1/*: any*/),
    {
      "alias": "popupGroups",
      "args": [
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/),
        {
          "kind": "Variable",
          "name": "searchTerm",
          "variableName": "searchTerm"
        },
        (v7/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/)
      ],
      "concreteType": "PopupGroupConnection",
      "kind": "LinkedField",
      "name": "__PopupListPage_popupGroups_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PopupGroupEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PopupGroup",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PopupTableDataRow_popupGroup"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/),
        {
          "kind": "Variable",
          "name": "searchText",
          "variableName": "searchTerm"
        },
        (v7/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "popupCsv",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Site",
  "abstractKey": null
};
})();

(node as any).hash = "34539e3a58876a08d53054874094d4b1";

export default node;
